// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_Toj","cls2":"ProfilePdfPackCard-cls2_-iT ProfilePdfPackCard-cls1_Toj"};